import * as React from 'react';
import { useSelector } from 'react-redux';

import { CardExtrasProviderProps, CardExtrasProvider } from './CardExtras.context';

import {
	getOrder,
	getFlight,
	getSegments,
	getTravellers,
	getAdditionalServices,
	getBrandIncludedBaggage
} from '../Checkout/store/order/selectors';
import { getPassengerStateCompatible, getSelectedServicesState } from '../Checkout/store/selectedServices/selectors';
import { useIsCheckinAvailable, useOrderServices } from '../Checkout/hooks';
import { getLoadingServiceTypesState } from '../Checkout/store/loadingServicesParams/selectors';

const CheckoutCardExtrasProvider: React.FC<CardExtrasProviderProps> = ({ children, userInfo, updateUser }) => {
	const order = useSelector(getOrder);
	const flight = useSelector(getFlight);
	const segments = useSelector(getSegments);
	const travellers = useSelector(getTravellers);
	const additionalServices = useSelector(getAdditionalServices);
	const passengers = useSelector(getPassengerStateCompatible);
	const selectedServices = useSelector(getSelectedServicesState);
	const brandIncludedBaggage = useSelector(getBrandIncludedBaggage);
	const loadingServiceParams = useSelector(getLoadingServiceTypesState);

	const isCheckinAvailable = useIsCheckinAvailable(order);
	const { isLoading, onSaveServicesRequest, onAddServices, onRemoveServices } = useOrderServices();

	return (
		<CardExtrasProvider
			value={{
				userInfo,
				updateUser,
				isCheckinAvailable,
				order,
				flight,
				segments,
				travellers,
				additionalServices,
				passengers,
				selectedServices,
				brandIncludedBaggage,
				loadingServiceParams,
				isLoading,
				onSaveServicesRequest,
				onSaveServices: onAddServices,
				onAddServices,
				onRemoveServices
			}}
		>
			{children}
		</CardExtrasProvider>
	);
};

export default CheckoutCardExtrasProvider;
